import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin, Tag } from "antd";
import { SearchOutlined, FileDoneOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const AvaliacoesFormulariosCargos = () => {
  const { id_avaliacao_formulario, id_avaliacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [avaliacaoFormulario, setAvaliacaoFormulario] = useState({});

  useEffect(() => {
    if (id_avaliacao_formulario) {
      carregarAvaliacaoFormulario(id_avaliacao_formulario);
      listarCargos(id_avaliacao_formulario);
    }
  }, [id_avaliacao_formulario]);

  // CARREGAR AVALIAÇÃO
  const carregarAvaliacaoFormulario = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_vinculo_formularios/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setAvaliacaoFormulario(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // LISTAR
  const listarCargos = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_cargos/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data.data);
      setSelected(api.response.data.checked);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes/gestao");
    }
    setLoading(false);
  };

  // SALVAR
  const salvarCargos = async (cargos_selected, cargos, idForm) => {
    if (avaliacaoFormulario?.status_formulario === 1) return false;
    setLoading(true);
    let array_cargos = [];
    cargos?.map((e) => {
      array_cargos.push(e.key);
    });

    const dados_envio = {
      id_avaliacoes_formularios: idForm,
      id_avaliacoes_cargos: array_cargos,
      id_avaliacoes_cargos_checked: cargos_selected,
    };

    const api = await http("post", `v1/avaliacoes_formularios_cargos/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_cargos.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...cargos_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Cargo <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "cargo",
      sorter: (a, b) => a.cargo?.localeCompare(b.cargo),
    },
    // {
    // 	title: "Total avaliadores possíveis",
    // 	dataIndex: "afetados",
    // 	render: (_, e) => (e.afetados > 0 ? <Tag color="green">{e.afetados}</Tag> : <Tag color="red">{e.afetados}</Tag>),
    // 	sorter: (a, b) => a.afetados?.toString()?.localeCompare(b.afetados?.toString()),
    // },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.cargo?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });

        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });

        break;
      default:
        break;
    }

    return filteredData;
  };

  // DADOS FILTER
  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarCargos(array, dadosFilter, id_avaliacao_formulario);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarCargos(status ? [data.key] : [], [{ key: data.key }], id_avaliacao_formulario);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Avaliações"
              onClickBack={() => navigate(`/avaliacoes/gestao/formularios/${id_avaliacao}`)}
            />
            <HeaderTitle
              title="Avaliação Liberação Cargos"
              subtitle={
                <Text italic>
                  <FileDoneOutlined /> <Tag>{avaliacaoFormulario?.avaliacao}</Tag>
                  {avaliacaoFormulario?.classificacao} - {avaliacaoFormulario?.formulario}
                </Text>
              }
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                scroll={{ x: 700 }}
                loading={loading}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
